<ng-container>
  <div class="modal-header">
    <h5 class="modal-title">{{'Comments'}}</h5>
  </div>
  @if ((orderStatusDetails$ | async); as orderStatusDetails) {
    <div class="modal-section">
      @for (orderStatusDetail of orderStatusDetails.orderStatusDetails; track orderStatusDetail) {
        @if ((orderStatus$ | async); as orderStatus) {
          <div class="modal-status">Order Status: {{orderStatus | titleCaseStatusCode}} - {{orderStatusDetail.categoryTypeValue}}</div>
          <div class="modal-comments">Comment: {{orderStatusDetail.comments}}</div>
          <hr>
          }
        }
      </div>
    }
    <div class="modal-footer">
      <button type="button" class="btn-secondary close-button" (click)="closeModal()">Close</button>
    </div>
  </ng-container>
